const TIER_COLORS: Record<string, string> = {
  Common: '#E5A015',
  Uncommon: '#A0BCDB',
  Rare: '#F6D730',
  Epic: '#25EA1E',
  Legendary: '#FF5BFF',
  Grail: '#FF3A3A',
};

const FALLBACK = '#9AA0A6';

export function tierColor(name: string): string {
  return TIER_COLORS[name] ?? FALLBACK;
}

/** Alias for {@link tierColor} — returns the base hex color string for a tier. */
export const tierColorFor = tierColor;

export function tierDotStyle(name: string): React.CSSProperties {
  const c = tierColor(name);
  return {
    backgroundColor: c,
    borderColor: `${c}33`,
    boxShadow: `0 0 4px 0 ${c}4d, inset 0 0 7px 0 ${c}99`,
  };
}
